import React from "react";
import { Link } from "react-router-dom";
import { COMMUNITY_REWARD } from "../../lib/communityReward";
import { HOME_CTA_DARK_OUTLINE } from "../../lib/homeCta";

/** Compact Routine Reward nudge — warm and small. */
export default function HomeCommunityReward() {
  const r = COMMUNITY_REWARD;

  return (
    <section id="reward" className="relative py-5 md:py-6 scroll-mt-24" aria-labelledby="community-reward-heading">
      <div className="max-w-lg mx-auto px-6 md:px-10">
        <div className="rounded-xl border border-[rgba(248,241,223,0.14)] bg-[color:var(--mm-panel-warm)]/90 px-5 py-4 md:px-5 md:py-4 text-center">
          <p className="home-eyebrow m-0 mb-1.5">{r.homepageEyebrow}</p>
          <h2
            id="community-reward-heading"
            className="font-sans font-semibold text-base md:text-lg text-ivory leading-snug m-0 tracking-tight"
          >
            {r.homepageLead}
          </h2>
          <p className="mt-2 text-sm text-sage leading-relaxed m-0">{r.homepageTerms}</p>
          <Link to="/community-reward" className={`${HOME_CTA_DARK_OUTLINE} mt-3.5 min-h-[38px] px-5 py-2 text-xs inline-flex`}>
            How it works
          </Link>
        </div>
      </div>
    </section>
  );
}
